import $http from "../../axios";
import {Notification} from "element-ui";
import {getApiDomain} from "../../util/domains";

export async function downloadAccountsTemplate({}) {
    await $http({
        url: `/api/descargar-plan-cuentas`,
        method: 'GET',
        responseType: 'blob' // important
    }).then(response => {
        var type_file = response.data.type.split('/')[1];

        //Descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `plantilla-plan-cuentas.${type_file}`);
        document.body.appendChild(link);
        link.click();
    });
}
export async function uploadAccountsTemplate({state,commit}) {
    let formData = new FormData();
    formData.append('file', state.file);
    formData.append('validated', state.params.validated);
    state.loading.module = true ;
    $http.post(`/api/cargar-plan-cuentas`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    ).then((response) => {
        commit('setValidationdata', response.data);
        commit('setloading', false);
        if (!response.data.success){
            window.open(getApiDomain() + response.data.url_report_error, '_blank');
            Notification.error({
                title: "Error!",
                message: 'El excel tiene informacion inocorrecta, por favor valida el excel con los errores encontrados',
                type: "error",
                duration: 10000,
                customClass: "notification-box"
            });
        }else{
            if (response.data.completed){
                commit('reset_state');
                Notification.success({
                    title: "Success!",
                    message: response.data.message,
                    type: "success",
                    duration: 4000,
                    customClass: "notification-box"
                });

            }else{
                Notification.success({
                    title: "Success!",
                    message: 'Validación Finalizada exitosamente',
                    type: "success",
                    duration: 4000,
                    customClass: "notification-box"
                });
            }

        }
    }).catch(error => {
        commit('setloading', false);
        state.params.validated = false;
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 3000,
            customClass: "notification-box"
        });
    });
}



// WEBPACK FOOTER //
// ./src/modules/import-accounts-plans/actions.js